import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getCasesBonus, patchCasesBonus, postCasesBonus } from "./thunks";
import { CasesBonus } from "../../../entities/cases_v2";

interface CasesBonusState {
  loading: boolean,
  saveLoading: boolean,
  bonus?: CasesBonus,
}

const initialState: CasesBonusState = {
  loading: false,
  saveLoading: false,
}

const saveCases = (
  builder: ActionReducerMapBuilder<CasesBonusState>,
  action: any
) => {
  builder.addCase(action.pending, (state: CasesBonusState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: CasesBonusState, action: PayloadAction<CasesBonus>) => {
    state.saveLoading = false;
    state.bonus = action.payload;
  });
  builder.addCase(action.rejected, (state: CasesBonusState) => {
    state.saveLoading = false;
  });
};

export const casesBonusStore = createSlice({
  name: "casesBonus",
  initialState: initialState,
  reducers: {
    clearBonus: (state) => {
      state.bonus = undefined;
    }
  },
  extraReducers: (builder) => {
    // getCasesBonus
    builder.addCase(getCasesBonus.pending, state => {
      state.loading = true;
    })
    builder.addCase(getCasesBonus.fulfilled, (state, action) => {
      state.bonus = action.payload;

      state.loading = false;
    })
    const saveActions = [patchCasesBonus,
      postCasesBonus];

    saveActions.forEach((action) => { saveCases(builder, action) })
  },
})

export const { clearBonus } = casesBonusStore.actions

export default casesBonusStore.reducer;